const childrenLoaded = require('@alexspirgel/children-loaded');

// Drupal's drupal.init.js calls jQuery.noConflict(), so the global $ is not
// guaranteed to exist. Reference jQuery directly.
const $ = window.jQuery;

class ComponentProgramFinderCTA extends HTMLDivElement {

	static getFormValues(element) {
		const formFieldNamesAndValues = {};
		const formData = new FormData(element);
		for (const entry of formData.entries()) {
			const name = entry[0];
			const value = entry[1];
			formFieldNamesAndValues[name] = value;
		}
		return formFieldNamesAndValues;
	}

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);

		this.programFinderPage = this.getAttribute('data-program-finder-page');

		this.exposedFormElement = this.querySelector('.views-exposed-form');
		this.submitElement = this.querySelector('.component-program-finder-cta__submit');

		$('.component-program-finder-cta .views-exposed-form select:not([name="career-interest"])').select2({
			minimumResultsForSearch: Infinity,
			width: 'style',
		});
		$('.component-program-finder-cta .views-exposed-form select[name="career-interest"]').select2({
			width: 'style',
		});
		
		this.exposedFormElement.addEventListener('submit', (event) => {
			event.preventDefault();
			this.submit();
			return false;
		});
		this.submitElement.addEventListener('click', this.submit);
	}

	applyQueryStringsToURL(url, queryStrings) {
		url = new URL(url, window.location.origin);
		for (let key in queryStrings) {
			url.searchParams.append(key, queryStrings[key]);
		}
		return url.href;
	}

	applyHashToURL(url, hash) {
		url = new URL(url, window.location.origin);
		url.hash = hash;
		return url.href;
	}

	submit = () => {
		const formValues = this.constructor.getFormValues(this.exposedFormElement);
		for (let key in formValues) {
			const value = formValues[key];
			if (value == 'All') {
				delete formValues[key];
			}
		}
		let href = this.applyQueryStringsToURL(this.programFinderPage, formValues);
		href = this.applyHashToURL(href, '#program-finder');
		window.location.href = href;
	}

}

customElements.define('component-program-finder-cta', ComponentProgramFinderCTA, {extends: 'div'});